/**
 * Two-column grid of always-open FAQ cards (question + answer), used on city,
 * index and About pages. For collapsible FAQs use FaqAccordion instead.
 */
import { Reveal } from "@/components/Reveal";

export function FaqCardGrid({
  items,
  headingLevel = "h3",
}: {
  items: readonly { q: string; a: string }[];
  /** Heading tag for each question; defaults to h3 under a section h2. */
  headingLevel?: "h2" | "h3";
}) {
  const Heading = headingLevel;
  return (
    <div className="grid md:grid-cols-2 gap-6">
      {items.map((f, i) => (
        <Reveal key={f.q} delay={i * 0.04}>
          <div className="rounded-3xl border border-border p-8 h-full bg-card">
            <Heading className="font-display text-lg">{f.q}</Heading>
            <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{f.a}</p>
          </div>
        </Reveal>
      ))}
    </div>
  );
}
